import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleSubmit } from "../../controller/PartFinancialController/CreatePartFinancialController";
import PartFinancialService from "../../controller/PartFinancialController/PartFinancialController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSite from "../../../Common/HelpLink";
function CreatePartFinancial() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ ID: "0", PurchaseNominal: '0', SaleNominal: '0' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);

    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        async function fetchPartFinancial() {
            try {
                debugger;
                const redirectCallback = () => {
                    navigate('/');
                };
                const PartFinancial = await PartFinancialService.GetAllPartFinancial(redirectCallback);
                setFormData({
                    PurchaseNominal: PartFinancial[0].PurchaseNominal,
                    SaleNominal: PartFinancial[0].SaleNominal,
                    ID: PartFinancial[0].ID
                });
            } catch (error) {
                console.error('Error fetching company setup:', error);
            }
        }
        fetchPartFinancial();
    }, [navigate]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {
        debugger;
        event.preventDefault();
        const redirectCallback = () => {
            navigate('/');
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        if (formData.ID == "undefined") {
            formData.ID = 0;
        }
        handleSubmit(event, formData, setFormData, setErrors, redirectCallback, redirectUserList);
        const updatedPartFinancial = await PartFinancialService.GetAllPartFinancialByID(redirectCallback, formData.ID);
        setFormData(updatedPartFinancial[0] || {});
        window.scrollTo(0, 0);
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Financials" Module="26" />
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>

                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Purchase Nominal</label>
                    <div className="col-sm-4">
                        <input type="hidden" className="form-control" name="ID" value={formData.ID} onChange={handleFieldChange} />
                        <input type="text" className="form-control" name="PurchaseNominal" value={formData.PurchaseNominal} onChange={handleFieldChange} />
                        {errors.PurchaseNominal && <div style={{ color: 'red' }}>{errors.PurchaseNominal}</div>}
                    </div>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Sale Nominal</label>
                    <div className="col-sm-4">

                        <input type="text" className="form-control" name="SaleNominal" value={formData.SaleNominal} onChange={handleFieldChange} />
                        {errors.SaleNominal && <div style={{ color: 'red' }}>{errors.SaleNominal}</div>}
                    </div>
                </div>
                <div className="row" style={{ "marginLeft": "0px", "float": "right", "marginRight": "0px" }}>
                    <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary">
                            <i className="icofont-save" aria-hidden="true"> Save

                            </i>
                        </button>

                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreatePartFinancial;
